import { DEFAULT_LOCALE } from "./intl";
import { Decimal as JsDecimal } from "decimal.js";

export class Float {
  value: number;
  constructor(value: number) {
    this.value = value;
  }
}

export class Integer {
  value: number;
  constructor(value: number) {
    this.value = value;
  }
}

export class Decimal {
  value: string;
  precision: number;
  scale: number;
  constructor(value: string, precision: number, scale: number) {
    this.value = value;
    this.precision = precision;
    this.scale = scale;
  }
}

export const getNumValue = (
  num: number | Float | Integer | Decimal,
): string | number => {
  if (typeof num === "number") {
    return num;
  }
  if (num instanceof Decimal) {
    return new JsDecimal(num.value)
      .toSignificantDigits(num.precision)
      .toFixed(num.scale)
      .toString();
  }
  return num.value;
};

export const formatNum = (
  num: number | bigint | Float | Integer | Decimal,
  locale = DEFAULT_LOCALE,
): string => {
  if (typeof num === "bigint") {
    return num.toLocaleString(locale);
  }
  const raw = getNumValue(num);
  const numberFormat = new Intl.NumberFormat(locale);

  if (typeof raw === "number") return numberFormat.format(raw);

  const parsed = Number(raw);
  return Number.isNaN(parsed) ? raw : numberFormat.format(parsed);
};

export function parsePositiveInt(raw: string | undefined): number | null {
  if (raw === undefined) return null;
  const parsed = parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
}
